import { lazyLoad } from 'utils/loadable';

export const JobDetailPage = lazyLoad(
  () => import('./index'),
  module => module.JobDetailPage,
);
